import { EditorProviderButtonSettings } from '../EditorProviderButtonSettings';
import { customizeCraftJsComponent } from '../../helpers';
import { EditorButton } from '../EditorButton';

export const EditorLinkedinButton = customizeCraftJsComponent(EditorButton, {
	name: 'Linkedin Button',
	props: {
		children: '',
		startIcon: 'linkedin',
		shape: 'square',
		variant: 'outline',
		'data-descope-provider': 'linkedin',
		startIconColorText: false,
		formNoValidate: true,
		'data-type': 'social'
	},
	related: {
		settings: EditorProviderButtonSettings
	},
	custom: {
		subType: 'social'
	}
});
